import { useMemo } from 'react';
import { NavTabs } from '@shared/tabs/NavTabs';
import { RequirementInfo } from './Requirement/Requirement';
import { RateCardsInfo } from './RateCard/RateCard';
import { ExcelViewer } from './BankBible/BankBible';

export const LenderInfoTabs = ({ lenderId }: { lenderId: string }) => {
  const withPlaceholder = (cmp: JSX.Element) => (!lenderId ? 'Please select lender' : cmp);

  const tabs = useMemo(
    () => [
      {
        name: 'Requirements',
        component: withPlaceholder(<RequirementInfo lenderId={lenderId} />),
      },
      {
        name: 'Rate Cards',
        component: withPlaceholder(<RateCardsInfo lenderId={lenderId} />),
      },
       {
        name: 'Bank Bible',
        component: withPlaceholder(<ExcelViewer />),
      },
    ],
    [lenderId]
  );

  return <NavTabs data={tabs} loading={false} />;
};